import { Point } from './GeoMarker.styles';

const GeoMarker = () => {
  return <Point />;
};

export default GeoMarker;
